import _get from 'lodash/get';
import { refreshAuth } from '../lock/refreshAuth.lock.actions';

export const autoSelectProfile = data => dispatch =>
  dispatch(
    refreshAuth({
      item: _get(data, 'blocks[0].content.items[0]'),
    }),
  );
